export enum MembershipErrors {
  DELETE = 'memberships/deleteMembership',
  CREATE = 'memberships/createMembership',
  EDIT = 'memberships/editMembership',
  GET = 'memberships/getMembership'
}
